module.exports = __webpack_public_path__ + "img/sx.a4ac1b11.svg";